import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoaderState } from '../types/loader.type'

const initialState: LoaderState = {
  loading: false,
  loaderArr: [],
  counter: 0,
  loaderText: '',
  loaderSubText: '',
  textLoadingState: false,
}

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader(state) {
      state.loading = true
      state.counter = state.counter + 1
    },
    showLoaderwithMessage(
      state,
      action: PayloadAction<
        | {
            loaderText?: string | undefined
            loaderSubText?: string | undefined
          }
        | undefined
      >
    ) {
      state.textLoadingState = true
      state.loaderText = action?.payload?.loaderText ?? ''
      state.loaderSubText = action?.payload?.loaderSubText ?? ''
    },
    showLoaderWithId(state, action) {
      state.loaderArr.push(action.payload)
    },
    hideLoader(state) {
      if (state.counter > 0) state.counter = state.counter - 1
      if (state.counter === 0) state.loading = false
    },
    hideLoaderWithId(state, action) {
      state.loaderArr = state.loaderArr.filter((id) => id !== action.payload)
    },
    hideLoaderClearMessage(state) {
      state.loaderText = ''
      state.loaderSubText = ''
      state.textLoadingState = false
    },
    resetLoader(state) {
      state.loading = false
      state.counter = 0
      state.textLoadingState = false
      state.loaderText = ''
      state.loaderSubText = ''
    },
  },
})

export const {
  showLoader,
  hideLoader,
  showLoaderWithId,
  hideLoaderWithId,
  hideLoaderClearMessage,
  showLoaderwithMessage,
  resetLoader,
} = loaderSlice.actions

export default loaderSlice.reducer
